import { Link, useLocation } from 'react-router-dom';
import { legalCopy } from '../../shared/legal-content';
import { Seo } from '../lib/seo';

export function LegalPage() {
  const location = useLocation();
  const copy = legalCopy[location.pathname] ?? legalCopy['/terms'];

  return (
    <section className="page-section legal-page">
      <Seo title={copy.title} description={copy.description} path={location.pathname} noindex />
      <div className="shell legal-shell">
        <p className="eyebrow">Legal and trust</p>
        <h1>{copy.title}</h1>
        <p className="legal-intro">{copy.intro}</p>
        <nav className="legal-jump" aria-label="Legal document sections">
          {copy.sections.map((section, index) => <a key={section.title} href={`#legal-${index + 1}`}>{section.title.replace(/^\d+\.\s*/, '')}</a>)}
        </nav>
        {copy.sections.map((section, index) => (
          <section key={section.title} id={`legal-${index + 1}`}>
            <h2>{section.title}</h2>
            {section.paragraphs.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
            {section.bullets && <ul>{section.bullets.map((bullet) => <li key={bullet}>{bullet}</li>)}</ul>}
            {section.title.includes('Contact') && <p><Link className="inline-link" to="/contact">Open the secure support form</Link></p>}
          </section>
        ))}
      </div>
    </section>
  );
}
